<template>
    <div>
      <div class="uk-section uk-section-small">
        <div class="uk-grid-small" uk-grid>
          <div class="uk-width-1-1">
            <h3>{{ user.given_name + ' ' + user.family_name }}</h3>
          </div>
          <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l">
            <form class="uk-form-horizontal" v-on:submit.prevent="updateUser">
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="given_name" class="uk-form-label">Given Name</label>
                  <div class="uk-form-controls">
                    <input id="given_name" type="text" class="uk-input" v-model="user.given_name" placeholder="Enter the given name" required>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="family_name" class="uk-form-label">Family Name</label>
                  <div class="uk-form-controls">
                    <input id="family_name" type="text" class="uk-input" v-model="user.family_name" placeholder="Enter the family name" required>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="email" class="uk-form-label">Email</label>
                  <div class="uk-form-controls">
                    <input id="email" type="email" class="uk-input" v-model="user.email" placeholder="Enter the email" required>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="password" class="uk-form-label">*Password</label>
                  <div class="uk-form-controls">
                    <input id="password" type="text" class="uk-input" minlength="3" v-model="user.password" placeholder="Enter the password">
                  </div>
                </div>
              </div>
              <div class="uk-margin" v-if="user.password.length > 3">
                <div class="uk-inline">
                  <label for="password_verify" class="uk-form-label">Verify Password</label>
                  <div class="uk-form-controls">
                    <input id="password_verify" type="text" class="uk-input" v-model="user.password_check" placeholder="Enter the password">
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <button class="uk-button uk-button-primary">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "Product",
    data() {
      return {
        user: {
          email: null,
          given_name: null,
          family_name: null,
          password: '',
          password_check: '',
          created_at: null,
          updated_at: null,
        }
      };
    },
    activated() {
      this.getUser();
    },
    mounted() {
      this.getUser();
    },
    methods: {
      getUser() {
        const self = this;

        self.$request().get(`/user/${self.$route.params.id}`)
          .then(r => {
            r = self.$request().successHandler(r).data;

            self.user.email = r.user.email;
            self.user.given_name = r.user.given_name;
            self.user.family_name = r.user.family_name;
            self.user.created_at = r.user.created_at;
            self.user.updated_at = r.user.updated_at;
          }).catch(e => {
            self.$router.push({name: 'PageNotFound'})
          });
      },
      updateUser() {
        const self = this;

        let data = {
          email: self.user.email,
          given_name: self.user.given_name,
          family_name: self.user.family_name,
        };

        if (self.user.password.length > 0 && self.user.password !== self.user.password_check) {
          self.$uikit().notification({
            message: 'Passwords don\'t match',
            status: 'warning',
            position: 'top-center',
            timeout: 5000,
          });
          return false;
        } else {
          data['password'] = self.user.password;
        }


        self.$request().put(`/user/${self.$route.params.id}`, data)
          .then(r => {
            self.$uikit().notification({
              message: 'The update was successfully completed.',
              status: 'success',
              position: 'top-center',
              timeout: 5000,
            });
          }).catch(e => {
            self.$uikit().notification({
              message: 'Something went wrong! Please try again later.',
              status: 'danger',
              position: 'top-center',
              timeout: 5000,
            });
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/Show.vue